import { useEffect } from "react";

/* Sets the browser tab title while a detail view is open (Invoice,
   Bill, Shipment, etc. — same idea as Xero's "Invoice INV-0001 |
   Client Name" tab title), restoring whatever the tab was called
   before as soon as the detail closes/unmounts. `title` is the full
   string to show; pass a falsy value to skip (e.g. while data is
   still loading) without touching the tab. */
export default function useDocumentTitle(title) {
  useEffect(function () {
    if (!title) return undefined;
    var prev = document.title;
    document.title = title;
    return function () { document.title = prev; };
  }, [title]);
}
